import { render, staticRenderFns } from "./SpecialDiscountOrderNotification.vue?vue&type=template&id=9afc1c3a"
import script from "./SpecialDiscountOrderNotification.vue?vue&type=script&lang=js"
export * from "./SpecialDiscountOrderNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports